/** Minimal stroke icon set (24px grid, drawn for this project). Decorative by default. */
const PATHS = {
  home: "M3 10.5 12 3l9 7.5M5 9v11h5v-6h4v6h5V9",
  map: "M9 4 3 6.5v13.5l6-2.5 6 2.5 6-2.5V4l-6 2.5L9 4Zm0 0v13.5m6-11V20",
  bell: "M6 16V11a6 6 0 1 1 12 0v5l1.5 2h-15L6 16Zm4 4a2 2 0 0 0 4 0",
  building: "M4 21V8l8-5 8 5v13M9 21v-5h6v5M8 11h2m4 0h2",
  truck: "M3 18V6h7v6h4l3-4h2v10M3 18h2m4 0h6m4 0h2M7 20a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm10 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
  chip: "M8 8h8v8H8V8Zm-3 1h3m-3 6h3m8-6h3m-3 6h3M9 5v3m6-3v3M9 16v3m6-3v3",
  user: "M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm-7 9a7 7 0 0 1 14 0",
  users: "M9 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm-6 9a6 6 0 0 1 12 0m1-9a3 3 0 1 0-1-5.8M21 20a5 5 0 0 0-4-4.9",
  card: "M3 6h18v12H3V6Zm0 4h18M7 15h4",
  key: "M14.5 9.5a4 4 0 1 0-1.4 3L20 19.5V22h-2.5v-2H15v-2.5l-1.9-1.9",
  chart: "M4 20V4m0 16h16M8 16v-5m4 5V8m4 8v-3",
  alert: "M12 3 2 20h20L12 3Zm0 6v5m0 3v.5",
  heat: "M12 21a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0-4a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0-3.5v-1",
  gauge: "M4 17a8 8 0 1 1 16 0M12 17l4-5M8 17h8",
  spaghetti: "M3 17c3-6 6 2 9-4s6 2 9-4M3 9c4 0 5 8 9 8s5-8 9-8M3 13h18",
  route: "M6 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm12-10a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM8 17h8a3 3 0 0 0 0-6H8a3 3 0 0 1 0-6h8",
  log: "M6 3h9l4 4v14H6V3Zm9 0v4h4M9 11h6m-6 4h6",
  settings:
    "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm7.4-3a7.4 7.4 0 0 0-.1-1.2l2-1.6-2-3.4-2.4 1a7 7 0 0 0-2-1.2L14.5 3h-5l-.4 2.6a7 7 0 0 0-2 1.2l-2.4-1-2 3.4 2 1.6a7.4 7.4 0 0 0 0 2.4l-2 1.6 2 3.4 2.4-1a7 7 0 0 0 2 1.2l.4 2.6h5l.4-2.6a7 7 0 0 0 2-1.2l2.4 1 2-3.4-2-1.6c.1-.4.1-.8.1-1.2Z",
  chevronRight: "m9 6 6 6-6 6",
  trendUp: "M12 19V5m-6 6 6-6 6 6",
  trendDown: "M12 5v14m-6-6 6 6 6-6",
  pulse: "M3 12h4l3-7 4 14 3-7h4",
  chevronDown: "m6 9 6 6 6-6",
  search: "M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14Zm5-2 4.5 4.5",
  filter: "M4 5h16l-6 7.5V18l-4 2v-7.5z",
  menu: "M4 7h16M4 12h16M4 17h16",
  close: "m6 6 12 12M18 6 6 18",
  logout: "M15 4h4v16h-4M10 8l-4 4 4 4m-4-4h10",
  arrowLeft: "M19 12H5m6-6-6 6 6 6",
  info: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm0-10v6m0-9v.5",
  check: "m5 12 5 5L20 7",
  clock: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm0-14v5l3 2",
  lock: "M6 11h12v10H6V11Zm2 0V8a4 4 0 1 1 8 0v3",
  box: "M3 7.5 12 3l9 4.5v9L12 21l-9-4.5v-9Zm0 0 9 4.5m0 0 9-4.5M12 12v9",
  plus: "M12 5v14M5 12h14",
  edit: "M4 20h4L19 9l-4-4L4 16v4Zm9-13 4 4",
  trash: "M4 7h16M9 7V4h6v3m-8 0 1 13h8l1-13",
  copy: "M8 8h11v12H8V8Zm-3 8V4h11",
  download: "M12 4v11m-5-5 5 5 5-5M5 20h14",
  link: "M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1",
  unlink: "M15.7 14 18.7 11a4 4 0 0 0-5.7-5.7L12 6.3M8.3 10 5.3 13a4 4 0 0 0 5.7 5.7l1-1M4 4l16 16",
  mail: "M3 6h18v12H3V6Zm0 0 9 7 9-7",
  refresh: "M20 11a8 8 0 1 0-2.3 5.7M20 4v7h-7",
  ban: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM5.6 5.6l12.8 12.8",
  eye: "M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12Zm9.5 3a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
  calendar: "M4 6h16v15H4V6Zm0 5h16M8 3v5m8-5v5",
  help: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm-2.5-11.5a2.5 2.5 0 1 1 3.6 2.2c-.7.4-1.1.9-1.1 1.7v.6m0 3v.5",
  eyeOff:
    "M4 4l16 16M10.5 5.6A9 9 0 0 1 12 5.5c6 0 9.5 6.5 9.5 6.5a16 16 0 0 1-2.9 3.7M6.8 6.9C4 8.7 2.5 12 2.5 12S6 18.5 12 18.5a9 9 0 0 0 4.9-1.4M9.9 9.9a3 3 0 0 0 4.2 4.2",
} as const;

export type IconName = keyof typeof PATHS;

export function Icon({ name, size = 18, className, label }: { name: IconName; size?: number; className?: string; label?: string }) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.7}
      strokeLinecap="round"
      strokeLinejoin="round"
      role={label ? "img" : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
      focusable="false"
    >
      <path d={PATHS[name]} />
    </svg>
  );
}
